  <template>
  <div class="h-full kendo-wrapper-height-adjust">
    <div class="loader" v-if="loading">
      <loading :opacity="0" :active.sync="loading" color="var(--primary-DEFAULT)"></loading>
    </div>
    <localization :language="spanish ? 'es-ES' : 'en-EN'">
      <intl :locale="spanish ? 'es' : 'en'">
        <Grid
          id="grid"
          ref="grid"
          expand-field="expanded"
          :data-items="dataResult"
          :edit-field="'inEdit'"
          :columns="kendo.columns"
          :reorderable="true"
          :resizable="true"
          :sortable="kendo.sortable"
          :filterable="kendo.filterable"
          :groupable="groupable"
          :skip="kendo.skip"
          :take="kendo.take"
          :sort="kendo.sort"
          :group="kendo.group"
          :filter="kendo.filter"
          :selectable="true"
          :selected-field="selectedField"
          :detail="kendo.detail"
          @datastatechange="datastatechange"
          @columnreorder="columnreorder"
          @selectionchange="selectionchange"
          @sortchange="sortchange"
          @headerselectionchange="headerselectionchange"
          @expandchange="expandchange">
          <template v-slot:myButtomTemplate="{ props }">
            <custom v-if="props.dataItem && !props.dataItem.aggregates" :class="props.className" :data-item="props.dataItem" @actionselect="actionSelected" />
          </template>
          <template v-slot:fechaTemplate="{ props }">
                <FechaTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  @click="clickHandler(props.dataItem)"
                ></FechaTemplate>
          </template>
          <template v-slot:checkboxTemplate="{ props }">
                <CheckboxTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  @click="clickHandler(props.dataItem)"
                ></CheckboxTemplate>
          </template>
          <template v-slot:tagsTemplate="{ props }">
                <TagsTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  @click="clickHandler(props.dataItem)"
                ></TagsTemplate>
          </template>
          <template v-slot:urlTemplate="{ props }">
                <UrlTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  @click="clickHandler(props.dataItem)"
                ></UrlTemplate>
          </template>
          <template v-slot:urlvisibleTemplate="{ props }">
                <UrlvisibleTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  @click="clickHandler(props.dataItem)"
                ></UrlvisibleTemplate>
          </template>
          <template v-slot:listTemplate="{ props }">
                <ListTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  @click="clickHandler(props.dataItem)"
                ></ListTemplate>
          </template>
          <template v-slot:groupsTemplate="{ props }">
                <GroupsTemplate
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="props.className"
                  @click="clickHandler(props.dataItem)"
                ></GroupsTemplate>
          </template>
          <template v-slot:selectTemplate="{ props }">
            <SelectTemplate
              :field="props.field"
              :expanded="props.expanded"
              :row-type="props.rowType"
              :level="props.level"
              :column-index="props.columnIndex"
              :columns-count="props.columnsCount"
              :data-item="props.dataItem"
              :class-name="props.className"
              @click="clickHandler(props.dataItem)"
              @selectChange="onSelectTemplateChange"
            ></SelectTemplate>
          </template>
          <template v-slot:myTemplateExpanded="{ props }">
            <DetailComponent :data-item="props.dataItem" />
          </template>
          <template v-slot:myTemplate="{ props }">
            <ColumnMenu 
              :column="props.column" 
              :filterable="props.filterable" 
              :filter="props.filter" 
              :sortable="props.sortable" 
              :sort="props.sort" 
              :columns="menuColumns" 
              @closemenu="(e) => { props.onClosemenu(e); onClosemenuAux(e); }"
              @columnssubmit="columnssubmit" 
              @sortchange="sortChangeColumn" 
              @filterchange="filterchange" />
          </template>
          <!-- <template v-slot:basic="{ props }">
            <CellComponent
                  :field="props.field"
                  :expanded="props.expanded"
                  :row-type="props.rowType"
                  :level="props.level"
                  :column-index="props.columnIndex"
                  :columns-count="props.columnsCount"
                  :data-item="props.dataItem"
                  :class-name="prop   s.className"
                  @click="clickHandler(props.dataItem)"
                ></CellComponent>
          </template> -->
          <grid-norecords>
            {{ noRecords }}
          </grid-norecords>
        </Grid>
      </intl>
    </localization>
  </div>
</template>

<script>
import { Grid, GridNoRecords } from '@progress/kendo-vue-grid'
import ColumnMenu from '@/components/kendo/ColumnMenu.vue'
import { IntlProvider, LocalizationProvider, loadMessages } from '@progress/kendo-vue-intl'
import { esMessages } from '@/config/grid-kendo.js'
import Loading from 'vue-loading-overlay'
import ActionCell from './ActionCell'
import CheckboxTemplate from '@/components/kendo/templates/CheckboxTemplate.vue'
import FechaTemplate from '@/components/kendo/templates/FechaTemplate.vue'
import TagsTemplate from '@/components/kendo/templates/TagsTemplate.vue'
import UrlTemplate from '@/components/kendo/templates/UrlTemplate.vue'
import UrlvisibleTemplate from '@/components/kendo/templates/UrlvisibleTemplate.vue'
import ListTemplate from '@/components/kendo/templates/ListTemplate.vue'
import GroupsTemplate from '@/components/kendo/templates/GroupsTemplate.vue'
import SelectTemplate from '@/components/kendo/templates/SelectTemplate.vue'
import DetailComponent from '@/components/kendo/DetailComponent.vue'
import moment from 'moment'
// import { i18n } from '@/i18n'
// import CellComponent from '@/components/kendo/CellComponent.vue'

loadMessages(esMessages, 'es-ES')

export default {
  name: 'kendo-grid-component',
  components: {
    Grid: Grid,
    'grid-norecords': GridNoRecords,
    ColumnMenu,
    localization: LocalizationProvider,
    intl: IntlProvider,
    Loading,
    custom: ActionCell,
    CheckboxTemplate,
    FechaTemplate,
    TagsTemplate,
    UrlTemplate,
    UrlvisibleTemplate,
    GroupsTemplate,
    SelectTemplate,
    ListTemplate,
    DetailComponent,
    // CellComponent,
  },
  props: {
    spanish: {
      type: Boolean,
      default: true
    },
    dataResult: {
      type: [Array, Object],
      default: null
    },
    kendo: {},
    selectedField: {
      type: String,
      default: 'selected'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      previousActiveElement: null
    }
  },
  computed: {
    noRecords: function () {
      return this.$t('components.kendoGrid.noRecords')
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    menuColumns: function () {
      return this.kendo.columns.filter(c => c.title)
    },
    noMenuColumns: function () {
      return this.kendo.columns.filter(c => !c.title)
    },
    groupable: function () {
      if (Object.prototype.hasOwnProperty.call(this.kendo, 'groupable')) {
        return this.kendo.groupable
      }
      return true
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    numDynamicColumns: function () {
      return 4
    },
    widthStaticColumns: function () {
      return 100
    }
  },
  watch: {},
  mounted: function () {
    this.grid = this.$refs.grid
    this.$root.$on('kendo-grid-componente-handle-resize', () => {
      this.handleResize()
    })
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    
    // Configurar accesibilidad WCAG 2.1 AA
    setTimeout(() => {
      this.$nextTick(() => {
        this.setupTableAccessibility()
        this.setupDOMObserver()
        this.setupColumnMenuFocusTrap()
      })
    }, 200)
  },
  created: function () {
    if (this.kendo.navigate === true) {
      const index = this.kendo.columns.findIndex((x) => x.cell === 'myButtomTemplate')
      // if (index === -1) this.kendo.columns.splice(1, 0, { field: ' ', title: '', cell: 'myButtomTemplate', filterable: false, width: '125px', locked: true, reorderable: false, groupable: false, sortable: false })
      if (index === -1) {
        if (this.kendo.columns[0].field === 'selected') this.kendo.columns.splice(1, 0, { field: ' ', title: ' Detalle', cell: 'myButtomTemplate', filterable: false, width: '100px', minResizableWidth: 100, locked: true, reorderable: false, groupable: false, sortable: false })
        else this.kendo.columns.splice(0, 0, { field: ' ', title: ' Detalle', cell: 'myButtomTemplate', filterable: false, width: '100px', minResizableWidth: 100, locked: true, reorderable: false, groupable: false, sortable: false })
      } 
    }
  },
  beforeDestroy: function () {
    // Limpiar recursos de accesibilidad
    if (this.domObserver) {
      this.domObserver.disconnect()
      this.domObserver = null
    }
    
    if (this.accessibilityRefreshTimeout) {
      clearTimeout(this.accessibilityRefreshTimeout)
      this.accessibilityRefreshTimeout = null
    }
    
    // Limpiar focus trap del column menu
    if (this._columnMenuKeydownHandler) {
      document.removeEventListener('keydown', this._columnMenuKeydownHandler)
      this._columnMenuKeydownHandler = null
    }
    
    // Limpiar event listeners
    window.removeEventListener('resize', this.handleResize)
    this.$root.$off('kendo-grid-componente-handle-resize')
  },
  methods: {
    onSelectTemplateChange (event) {
      this.$emit('onSelectTemplateChange', event)
    },
    formatDate: function (strDate) {
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    isDate: function (strDate) {
      if (strDate === undefined || strDate === null) return false
      const year = new Date(strDate).getFullYear()
      if (year >= 2000) return true
      return false
    },
    datastatechange: function (event) {
      this.$emit('datastatechange', event)
      // Refrescar accesibilidad después de cambios de datos
      this.$nextTick(() => {
        this.refreshTableAccessibility()
      })
    },
    columnreorder: function (event) {
      this.$emit('columnreorder', event)
      // Refrescar accesibilidad después de reordenar columnas
      this.$nextTick(() => {
        this.refreshTableAccessibility()
      })
    },
    expandchange: function (event) {
      // this.$emit('expandchange', event)
      // if (event.dataItem.expanded === undefined) {
      //   this.setExpandChange(event)
      // }
      this.setExpandChange(event)
    },
    setExpandChange (event) {
      this.$set(
        event.dataItem,
        event.target.$props.expandField,
        event.dataItem.expanded === undefined ? false : !event.dataItem.expanded
      )
    },
    rowclick: function (event) {
      this.$emit('rowclick', event)
    },
    columnssubmit: function (event) {
      const columns = this.noMenuColumns.concat(event)
      this.$emit('columnssubmit', columns)
    },
    onClosemenuAux: function (e) {
      setTimeout(() => {
        // Marcar el botón como colapsado (aria-expanded="false")
        if (this._currentColumnMenuButton) {
          this._currentColumnMenuButton.setAttribute('aria-expanded', 'false')
          this._currentColumnMenuButton.removeAttribute('aria-owns')
        }
        
        if (this._focusAfterMenuClose) {
          this._focusAfterMenuClose.focus()
          this._focusAfterMenuClose = null
        } else if (this._currentColumnMenuButton) {
          this._currentColumnMenuButton.focus()
        } else if (this.previousActiveElement) {
          this.previousActiveElement.focus()
        }
        this.previousActiveElement = null
        this._currentColumnMenuButton = null
        
        // Refrescar las etiquetas de los botones con estado de ordenación actualizado
        this.$nextTick(() => {
          const gridElement = this.$refs.grid?.$el || document.querySelector('#grid')
          if (gridElement) {
            this.setupColumnMenuButtonAccessibility(gridElement)
          }
        })
      }, 200)
    },  
    sortchange: function (event) {
      // Guardar el elemento con foco en data
      this.previousActiveElement = document.activeElement
      if (event?.event?.event) {
        if (event.event.event instanceof MouseEvent) {
          // console.log('Evento lanzado por ratón')
          this.$emit('sortchange', event)
        } else {
          // console.log('Evento lanzado por teclado u otro origen')
          // Abrir el ColumnMenu de la columna correspondiente
          if (this.grid && this.grid.$el && event?.event?.field) {
            const columnHeaders = this.grid.$el.querySelectorAll('.k-header')
            // Buscar el índice de la columna visible que corresponde al field
            let colIdx = -1
            let visibleIdx = 0
            for (let i = 0; i < this.kendo.columns.length; i++) {
              const col = this.kendo.columns[i]
              // Considerar solo columnas visibles (sin hidden: true)
              if (!col.hidden) {
                if (col.field === event.event.field) {
                  colIdx = visibleIdx
                  break
                }
                visibleIdx++
              }
            }
            if (colIdx !== -1 && columnHeaders.length > colIdx) {
              const menuButton = columnHeaders[colIdx].querySelector('.k-grid-column-menu')
              if (menuButton) {
                menuButton.click()
                // El foco se restaurará en onClosemenuAux
              } else {
                console.log('No se encontró el botón de ColumnMenu en la columna', colIdx, 'field:', event.event.field)
              }
            } else {
              console.log('No existe la columna visible con field', event.event.field)
            }
          }
        }
      }
    },
    sortChangeColumn (newDescriptor, e) {
      this.$emit('sortchange', newDescriptor, e)
      // this.onClosemenuAux(e)
    },
    filterchange: function (event) {
      this.$emit('filterchange', event)
    },
    selectionchange: function (event) {
      this.$emit('selectionchange', event)
    },
    headerselectionchange: function (event) {
      this.$emit('headerselectionchange', event)
    },
    actionSelected: function (e) {
      this.$emit('rowclick', e)
    },
    handleResize: function () {
      // const self = this
      // setTimeout(() => {
      //   if (self.grid !== undefined) {
      //     const currentVisibleColumns = self.kendo.columns.filter((c) => !(c.minGridWidth > self.grid.offsetWidth))
      //     if (currentVisibleColumns.length !== self.kendo.columns.length) {
      //       self.kendo.columns = currentVisibleColumns
      //     }
      //     const mapedColumns = self.kendo.columns.map(column => {
      //       if (self.isLower1024) {
      //         if (column.minWidth !== undefined && column.minWidth !== null) {
      //           column.width = column.minWidth
      //         }
      //       } else {
      //         if (column.minWidth !== undefined && column.minWidth !== null) {
      //           const topWidth = document.querySelector('#grid > div.k-grouping-header.k-grouping-header-flex').clientWidth
      //           column.width = ((topWidth - self.widthStaticColumns) / self.numDynamicColumns) + 'px'
      //           // column.width = '100%'
      //           // delete column.width
      //         } 
      //       }
      //       return column
      //     })
      //     self.kendo.columns = mapedColumns
      //   }
      // }, 50)
      if (this.grid !== undefined) {
        const currentVisibleColumns = this.kendo.columns.filter((c) => !(c.minGridWidth > this.grid.offsetWidth))
        if (currentVisibleColumns.length !== this.kendo.columns.length) {
          this.kendo.columns = currentVisibleColumns
        }
      }
    },
    getNestedValue: function (fieldName, dataItem) {
      return Object.prototype.hasOwnProperty.call(dataItem, fieldName) ? dataItem[fieldName] : false
    },
    
    // Métodos de accesibilidad WCAG 2.1 AA
    setupTableAccessibility: function () {
      // console.log('🔧 Iniciando setupTableAccessibility')
      try {
        const gridElement = this.$refs.grid?.$el || document.querySelector('#grid')
        if (!gridElement) {
          // console.warn('❌ No se encontró gridElement')
          return
        }
        // console.log('✅ GridElement encontrado:', gridElement)
        
        // Configurar el contenedor principal del grid con role="grid"
        const gridContainer = gridElement.querySelector('.k-grid')
        if (gridContainer) {
          if (!gridContainer.getAttribute('role') || gridContainer.getAttribute('role') === 'presentation') {
            gridContainer.setAttribute('role', 'grid')
          }
          // Añadir aria-label al contenedor si no existe
          if (!gridContainer.getAttribute('aria-label') && !gridContainer.getAttribute('aria-labelledby')) {
            gridContainer.setAttribute('aria-label', this.$t('components.kendoGrid.dataTable'))
          }
        }
        
        // Optimización: Remover todos los role="presentation" innecesarios de elementos de tabla en una sola pasada
        const tableStructureElements = gridElement.querySelectorAll('table, thead, tbody, tfoot, tr, th, td, colgroup, col, [role="presentation"]')
        tableStructureElements.forEach(element => {
          const tagName = element.tagName.toLowerCase()
          const isTableElement = ['table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'colgroup', 'col'].includes(tagName)
          
          if ((isTableElement || element.getAttribute('role') === 'presentation') && element.getAttribute('role') === 'presentation') {
            element.removeAttribute('role')
            // console.log(`Removido role="presentation" de ${tagName} para mantener estructura WCAG 2.1 AA`)
          }
        })
        
        // Remover role="grid" de tablas internas (Kendo genera tablas para cabecera y contenido)
        const internalTables = gridElement.querySelectorAll('.k-grid-header table, .k-grid-content table')
        internalTables.forEach(table => {
          if (table.getAttribute('role') === 'grid' || table.getAttribute('role') === 'presentation') {
            table.removeAttribute('role')
          }
          // Las tablas internas deben ser semánticas pero no tener role="grid"
        })
        
        // Asegurar que las cabeceras tengan los atributos ARIA correctos
        const columnHeaders = gridElement.querySelectorAll('.k-header, th')
        columnHeaders.forEach((header, index) => {
          // Asegurar role correcto para cabecera
          if (header.tagName.toLowerCase() === 'th') {
            if (!header.getAttribute('role') || header.getAttribute('role') === 'presentation') {
              header.setAttribute('role', 'columnheader')
            }
            
            // Asegurar scope para accesibilidad
            if (!header.getAttribute('scope')) {
              header.setAttribute('scope', 'col')
            }
          } else if (header.classList.contains('k-header')) {
            // Para elementos con clase k-header
            if (!header.getAttribute('role') || header.getAttribute('role') === 'presentation') {
              header.setAttribute('role', 'columnheader')
            }
          }
          
          // Añadir aria-label basado en contenido de cabecera si no existe
          if ((!header.getAttribute('aria-label') && !header.getAttribute('aria-labelledby')) || header.getAttribute('aria-label') === '') {
            const headerText = header.textContent?.trim()
            if (headerText && headerText.length > 0) {
              header.setAttribute('aria-label', headerText)
            }
          }
        })
        
        // Configurar celdas de datos con role="gridcell" para mejor accesibilidad
        const dataCells = gridElement.querySelectorAll('tbody td')
        dataCells.forEach((cell) => {
          if (!cell.getAttribute('role') || cell.getAttribute('role') === 'presentation') {
            cell.setAttribute('role', 'gridcell')
          }
        })
        
        // Configurar filas con role="row"
        const rows = gridElement.querySelectorAll('tbody tr')
        rows.forEach((row) => {
          if (!row.getAttribute('role') || row.getAttribute('role') === 'presentation') {
            row.setAttribute('role', 'row')
          }
        })
        
        // Mejorar accesibilidad del botón del ColumnMenu
        this.setupColumnMenuButtonAccessibility(gridElement)
        
        // Añadir role="button" a las cabeceras interactivas de columna
        this.setupColumnHeadersButtonAccessibility(gridElement)
        
        // Configurar accesibilidad para checkboxes de selección de filas
        // console.log('🔧 Llamando a setupRowSelectionAccessibility')
        this.setupRowSelectionAccessibility(gridElement)
        // console.log('✅ setupTableAccessibility completado')
      } catch (error) {
        console.error('❌ Error configurando accesibilidad de tabla:', error)
      }
    },
    
    refreshTableAccessibility: function () {
      // Debounced refresh para evitar llamadas excesivas
      if (this.accessibilityRefreshTimeout) {
        clearTimeout(this.accessibilityRefreshTimeout)
      }
      
      this.accessibilityRefreshTimeout = setTimeout(() => {
        this.setupTableAccessibility()
      }, 100)
    },
    
    setupDOMObserver: function () {
      try {
        const gridElement = this.$refs.grid?.$el || document.querySelector('#grid')
        if (!gridElement) return
        
        // Observer para detectar cambios en el DOM del grid
        this.domObserver = new MutationObserver((mutations) => {
          let shouldRefresh = false
          
          mutations.forEach((mutation) => {
            // Verificar si se agregaron nodos con role="presentation"
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                  const hasPresentation = node.getAttribute?.('role') === 'presentation' ||
                                        node.querySelector?.('[role="presentation"]')
                  if (hasPresentation) {
                    shouldRefresh = true
                  }
                  
                  // Verificar si se agregaron nuevos botones del ColumnMenu
                  if (node.classList?.contains('k-grid-column-menu') || 
                      node.querySelector?.('.k-grid-column-menu')) {
                    shouldRefresh = true
                  }
                }
              })
            }
            
            // Verificar cambios de atributos
            if (mutation.type === 'attributes' && mutation.attributeName === 'role') {
              if (mutation.target.getAttribute('role') === 'presentation') {
                shouldRefresh = true
              }
            }
          })
          
          if (shouldRefresh) {
            this.refreshTableAccessibility()
          }
        })
        
        // Observar cambios en el grid
        this.domObserver.observe(gridElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['role']
        })
      } catch (error) {
        console.error('Error configurando observer DOM:', error)
      }
    },
    
    setupRowSelectionAccessibility: function (gridElement) {
      // console.log('🔧 Iniciando setupRowSelectionAccessibility')
      try {
        // Configurar checkbox de selección en cabecera (seleccionar todo)
        const headerCheckbox = gridElement.querySelector('.k-header .k-checkbox')
        // console.log('🔍 Buscando headerCheckbox:', headerCheckbox)
        if (headerCheckbox && !headerCheckbox.getAttribute('aria-label')) {
          headerCheckbox.setAttribute('aria-label', this.$t('components.kendoGrid.selectAllRows'))
          headerCheckbox.setAttribute('title', this.$t('components.kendoGrid.selectAllRows'))
          // console.log('✅ Configurada accesibilidad para checkbox de selección de cabecera')
        }
        
        // Configurar checkboxes de filas con estrategia de retry
        // console.log('🔧 Llamando a setupRowCheckboxesWithRetry')
        this.setupRowCheckboxesWithRetry(gridElement, 0)
        // console.log('✅ setupRowSelectionAccessibility completado')
      } catch (error) {
        console.error('❌ Error configurando accesibilidad de checkboxes de selección:', error)
      }
    },
    
    setupRowCheckboxesWithRetry: function (gridElement, attempt) {
      const maxAttempts = 3
      const delay = 200 + (attempt * 100)
      
      setTimeout(() => {
        try {
          const rowCheckboxes = gridElement.querySelectorAll('tbody .k-checkbox')
          
          if (rowCheckboxes.length === 0) {
            if (attempt < maxAttempts) {
              this.setupRowCheckboxesWithRetry(gridElement, attempt + 1)
            }
            return
          }
          
          let configuredCount = 0
          
          rowCheckboxes.forEach((checkbox, index) => {
            if (!checkbox.getAttribute('aria-label')) {
              const row = checkbox.closest('tr')
              if (!row) return
              
              checkbox.setAttribute('aria-label', this.$t('components.kendoGrid.selectRow'))
              checkbox.setAttribute('title', this.$t('components.kendoGrid.selectRow'))
              configuredCount++
            }
          })
          
          if (configuredCount > 0) {
            // console.log(`Configurada accesibilidad para ${configuredCount} checkboxes de selección`)
          }
        } catch (error) {
          console.error('Error configurando checkboxes:', error)
        }
      }, delay)
    },
    
    setupColumnHeadersButtonAccessibility: function (gridElement) {
      try {
        const headerCells = gridElement.querySelectorAll('th.k-header')
        headerCells.forEach((th) => {
          const link = th.querySelector('.k-link')
          if (!link) return

          const tagName = link.tagName.toLowerCase()
          // <span> y <a> sin href carecen de semántica nativa de botón
          if (tagName === 'span' || (tagName === 'a' && !link.getAttribute('href'))) {
            if (!link.getAttribute('role')) {
              link.setAttribute('role', 'button')
            }
            // if (!link.getAttribute('tabindex')) {
            //   link.setAttribute('tabindex', '0')
            // }
          }
        })
      } catch (error) {
        console.error('Error configurando accesibilidad de cabeceras de columna:', error)
      }
    },

    setupColumnMenuButtonAccessibility: function (gridElement) {
      try {
        // Buscar todos los botones del ColumnMenu
        const columnMenuButtons = gridElement.querySelectorAll('.k-grid-column-menu')
        
        columnMenuButtons.forEach((btn, index) => {
          // Asegurar que sea un botón semántico
          if (btn.tagName.toLowerCase() !== 'button') {
            btn.setAttribute('role', 'button')
          }
          
          // Determinar el nombre de la columna asociada al botón
          const headerCell = btn.closest('th.k-header, .k-header')
          const columnTitle = headerCell ? (headerCell.getAttribute('aria-label') || headerCell.textContent?.trim()) : ''
          
          // Determinar estado de ordenación actual de la columna
          const sortState = this.getColumnSortState(columnTitle)
          
          // Configurar aria-label descriptivo incluyendo estado de ordenación
          let label = this.$t('components.kendoGrid.columnMenuAriaLabel', { column: columnTitle || '' })
          if (sortState) label += ' – ' + sortState
          btn.setAttribute('aria-label', label.trim())
          
          // Configurar tabindex para que sea navegable con teclado
          if (!btn.getAttribute('tabindex')) {
            btn.setAttribute('tabindex', '0')
          }
          
          // Remover title (aria-label es primario)
          if (btn.getAttribute('title')) {
            btn.removeAttribute('title')
          }
          
          // aria-haspopup="menu" (indicar que abre un menú)
          btn.setAttribute('aria-haspopup', 'menu')
          
          // aria-expanded: false por defecto (se actualiza al abrir/cerrar)
          if (!btn.hasAttribute('aria-expanded')) {
            btn.setAttribute('aria-expanded', 'false')
          }
          
          // Generar ID único para aria-owns
          const menuId = 'columnmenu-popup-' + index
          btn.setAttribute('data-columnmenu-id', menuId)
          
          // Rastrear qué botón abrió el menú para gestionar el foco al cerrar
          if (!btn._focusTrapTracked) {
            btn._focusTrapTracked = true
            btn.addEventListener('click', () => {
              this._currentColumnMenuButton = btn
              this.onColumnMenuButtonActivated(btn, menuId)
            })
            btn.addEventListener('keydown', (evt) => {
              if (evt.key === 'Enter' || evt.key === ' ') {
                this._currentColumnMenuButton = btn
                this.onColumnMenuButtonActivated(btn, menuId)
              }
            })
          }
        })
      } catch (error) {
        console.error('Error configurando accesibilidad del ColumnMenu:', error)
      }
    },
    
    // Obtener el estado de ordenación actual de una columna por su título
    getColumnSortState: function (columnTitle) {
      if (!this.kendo.sort || !columnTitle) return ''
      
      // Buscar la columna por título para obtener su field
      const col = this.kendo.columns.find(c => c.title && c.title.trim() === columnTitle)
      if (!col) return ''
      
      const sortDescriptor = this.kendo.sort.find(s => s.field === col.field)
      if (!sortDescriptor) return ''
      
      return sortDescriptor.dir === 'asc' ? this.$t('components.kendoGrid.sortAsc') : this.$t('components.kendoGrid.sortDesc')
    },
    
    // Gestión cuando se activa un botón de menú de columna
    onColumnMenuButtonActivated: function (btn, menuId) {
      // Marcar como expandido
      btn.setAttribute('aria-expanded', 'true')
      
      // Buscar el popup que aparecerá en el DOM (Kendo lo crea al final del body)
      // Usar un MutationObserver temporal para detectar cuando aparece
      const popupObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType !== 1) continue
            const popup = node.classList?.contains('k-grid-columnmenu-popup')
              ? node
              : node.querySelector?.('.k-grid-columnmenu-popup')
            if (popup) {
              // Vincular popup al botón mediante aria-owns
              popup.setAttribute('id', menuId)
              btn.setAttribute('aria-owns', menuId)
              
              // Configurar el popup con role adecuado si no lo tiene
              if (!popup.getAttribute('role')) {
                popup.setAttribute('role', 'menu')
              }
              popup.setAttribute('aria-label', btn.getAttribute('aria-label'))
              
              // Configurar navegación por flechas dentro del popup
              this.setupArrowKeyNavigation(popup)
              
              popupObserver.disconnect()
              return
            }
          }
        }
      })
      
      popupObserver.observe(document.body, { childList: true, subtree: true })
      
      // Timeout de seguridad para desconectar el observer
      setTimeout(() => {
        popupObserver.disconnect()
      }, 2000)
    },
    
    // Navegación por flechas dentro del menú popup (WAI-ARIA menu pattern)
    setupArrowKeyNavigation: function (popup) {
      if (popup._arrowNavConfigured) return
      popup._arrowNavConfigured = true
      
      popup.addEventListener('keydown', (e) => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) return
        
        e.preventDefault()
        e.stopPropagation()
        
        const focusableSelector = [
          'a[href]:not([disabled])',
          'button:not([disabled])',
          'input:not([disabled]):not([type="hidden"])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]:not([tabindex="-1"]):not([disabled])',
          '[role="menuitem"]',
          '[role="menuitemradio"]',
          '[role="menuitemcheckbox"]'
        ].join(', ')
        
        const focusableElements = Array.from(popup.querySelectorAll(focusableSelector))
          .filter(el => {
            if (el === popup) return false
            const rect = el.getBoundingClientRect()
            if (rect.width === 0 && rect.height === 0) return false
            let parent = el
            while (parent && parent !== popup) {
              const style = window.getComputedStyle(parent)
              if (style.display === 'none' || style.visibility === 'hidden') return false
              parent = parent.parentElement
            }
            return true
          })
        
        if (focusableElements.length === 0) return
        
        const currentIndex = focusableElements.indexOf(document.activeElement)
        let nextIndex = -1
        
        switch (e.key) {
          case 'ArrowDown':
            nextIndex = currentIndex < focusableElements.length - 1 ? currentIndex + 1 : 0
            break
          case 'ArrowUp':
            nextIndex = currentIndex > 0 ? currentIndex - 1 : focusableElements.length - 1
            break
          case 'Home':
            nextIndex = 0
            break
          case 'End':
            nextIndex = focusableElements.length - 1
            break
        }
        
        if (nextIndex >= 0 && focusableElements[nextIndex]) {
          focusableElements[nextIndex].focus()
        }
      })
    },
    
    // WCAG 2.1 AA: Gestión del foco al tabular dentro del menú de columna
    // Al llegar al último elemento con Tab, cierra el menú y enfoca el siguiente botón de tres puntos.
    // Al llegar al primer elemento con Shift+Tab, cierra el menú y enfoca el botón anterior.
    setupColumnMenuFocusTrap: function () {
      this._focusAfterMenuClose = null
      this._currentColumnMenuButton = null
      
      this._columnMenuKeydownHandler = (e) => {
        const activeElement = document.activeElement
        if (!activeElement) return
        
        // Buscar el contenedor real del menú de columna (.k-grid-columnmenu-popup)
        const menuPopup = activeElement.closest('.k-grid-columnmenu-popup')
        if (!menuPopup) return
        
        // Manejar Escape: cerrar menú y devolver foco al botón
        if (e.key === 'Escape') {
          e.preventDefault()
          e.stopPropagation()
          
          if (this._currentColumnMenuButton) {
            this._currentColumnMenuButton.setAttribute('aria-expanded', 'false')
            this._currentColumnMenuButton.removeAttribute('aria-owns')
            this._focusAfterMenuClose = this._currentColumnMenuButton
          }
          
          // Disparar Escape en el popup para que Kendo lo cierre
          menuPopup.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Escape',
            code: 'Escape',
            keyCode: 27,
            which: 27,
            bubbles: true,
            cancelable: true
          }))
          
          // Fallback de foco
          setTimeout(() => {
            if (this._focusAfterMenuClose) {
              this._focusAfterMenuClose.focus()
              this._focusAfterMenuClose = null
              this._currentColumnMenuButton = null
            }
          }, 350)
          return
        }
        
        if (e.key !== 'Tab') return
        
        // Obtener todos los elementos enfocables visibles dentro del menú completo
        const focusableSelector = [
          'a[href]:not([disabled])',
          'button:not([disabled])',
          'input:not([disabled]):not([type="hidden"])',
          'select:not([disabled])',
          'textarea:not([disabled])',
          '[tabindex]:not([tabindex="-1"]):not([disabled])'
        ].join(', ')
        
        const focusableElements = Array.from(menuPopup.querySelectorAll(focusableSelector))
          .filter(el => {
            // Excluir el propio contenedor del popup (no es interactivo, solo estructural)
            if (el === menuPopup) return false
            // Comprobar visibilidad real recorriendo ancestros hasta el menú
            const rect = el.getBoundingClientRect()
            if (rect.width === 0 && rect.height === 0) return false
            let parent = el
            while (parent && parent !== menuPopup) {
              const style = window.getComputedStyle(parent)
              if (style.display === 'none' || style.visibility === 'hidden') return false
              parent = parent.parentElement
            }
            return true
          })
        
        if (focusableElements.length === 0) return
        
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]
        
        const isAtEnd = !e.shiftKey && activeElement === lastElement
        const isAtStart = e.shiftKey && (activeElement === firstElement || activeElement === menuPopup)
        
        if (!isAtEnd && !isAtStart) return
        
        e.preventDefault()
        e.stopPropagation()
        
        // Obtener todos los botones de tres puntos del grid
        const gridElement = this.$refs.grid?.$el || document.querySelector('#grid')
        if (!gridElement) return
        const allMenuButtons = Array.from(gridElement.querySelectorAll('.k-grid-column-menu'))
        
        // Encontrar el índice del botón que abrió este menú
        const currentButton = this._currentColumnMenuButton
        const currentIndex = currentButton ? allMenuButtons.indexOf(currentButton) : -1
        
        // Determinar el botón destino
        let targetButton = null
        if (isAtEnd) {
          // Tab en último elemento → siguiente botón de tres puntos
          if (currentIndex >= 0 && currentIndex < allMenuButtons.length - 1) {
            targetButton = allMenuButtons[currentIndex + 1]
          } else {
            targetButton = currentButton
          }
        } else if (isAtStart) {
          // Shift+Tab en primer elemento → botón de tres puntos anterior
          if (currentIndex > 0) {
            targetButton = allMenuButtons[currentIndex - 1]
          } else {
            targetButton = currentButton
          }
        }
        
        // Marcar el menú como cerrado
        if (this._currentColumnMenuButton) {
          this._currentColumnMenuButton.setAttribute('aria-expanded', 'false')
          this._currentColumnMenuButton.removeAttribute('aria-owns')
        }
        
        // Guardar el destino del foco para cuando el menú se cierre
        this._focusAfterMenuClose = targetButton
        
        // Cerrar el menú disparando Escape
        activeElement.dispatchEvent(new KeyboardEvent('keydown', {
          key: 'Escape',
          code: 'Escape',
          keyCode: 27,
          which: 27,
          bubbles: true,
          cancelable: true
        }))
        
        // Fallback: si el menú no se cerró con Escape, forzar el foco después de un delay
        setTimeout(() => {
          if (this._focusAfterMenuClose) {
            this._focusAfterMenuClose.focus()
            this._focusAfterMenuClose = null
            this._currentColumnMenuButton = null
          }
        }, 350)
      }
      
      document.addEventListener('keydown', this._columnMenuKeydownHandler)
    }
  }
}
</script>

<style lang="scss">
.kendo-wrapper-height-adjust {
  & > div:not(.vld-overlay) {
    height: 100%;
    & > div:not(.vld-overlay) {
      height: 100%;
    }
  }
}
.k-grid {
  height: 100%;
}
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba($color: #ffffff, $alpha: 0.3);
}
</style>
